import { idParam, ROLES } from "../../../helpers/commons.helpers";

/**
 * Partner route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with properties
 * used by navigation guards and permission checks.
 *
 * @typedef {Object} PartnerRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires authentication.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/partners",
        name: "Partners",
        meta: {
            title: "Partners",
            modules: ["partners"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },

        component: () =>
            import(
            /* webpackChunkName: "partners" */ "@/modules/partners/pages/Partners"
            )
    },
    {
        path: "/partners/new",
        name: "NewPartner",
        component: () =>
            import(
            /* webpackChunkName: "partners" */ "@/modules/partners/pages/NewPartner"
            ),
        meta: {
            title: "New Partner",
            modules: ["partners"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        }
    },
    {
        path: `/partners/${idParam()}`,
        name: "PartnerProfile",
        meta: {
            title: "Partner Profile",
            modules: ["partners"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
            /* webpackChunkName: "partners" */ "@/modules/partners/pages/PartnerProfile"
            )
    }
]